// src/pages/Predictions2025.js
// 2025 Season - Predictions Disabled
// Redirect to Leaderboard

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Predictions2025() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to 2025 leaderboard after showing message
    const timer = setTimeout(() => {
      navigate('/leaderboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-12 text-center border border-blue-600 shadow-2xl">
          <div className="mb-6">
            <div className="text-6xl mb-4">🏁</div>
            <h1 className="text-4xl font-bold text-white mb-4">2025 Season Complete</h1>
          </div>

          <div className="bg-blue-800 bg-opacity-50 p-6 rounded-lg mb-6 border border-blue-500">
            <p className="text-xl text-blue-100 mb-4">
              The 2025 season has concluded. Predictions are now closed.
            </p>
            <p className="text-lg text-blue-200">
              You can view the final leaderboard and race results below.
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-blue-300">
              For the <strong>2026 season</strong>, you'll be able to submit new predictions!
            </p>
            <p className="text-sm text-blue-400">
              Redirecting to leaderboard in 3 seconds...
            </p>
          </div>

          <div className="mt-8 space-x-4">
            <button
              onClick={() => navigate('/leaderboard')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors"
            >
              View Leaderboard
            </button>
            <button
              onClick={() => navigate('/results')}
              className="bg-gray-700 hover:bg-gray-600 text-white font-bold py-3 px-6 rounded-lg transition-colors"
            >
              View Results
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Predictions2025;